// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"white\" stroke-width=\"4.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"20 6 9 17 3 12\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkbox_checkbox-container__Gpp8K {
  display: flex;
  gap: 10px;
  flex-direction: column;
  position: relative;
  width: fit-content;
}
.Checkbox_checkbox-container--disabled__Rfr\\+3 {
  cursor: not-allowed;
}
.Checkbox_checkbox-container--disabled__Rfr\\+3 .Checkbox_checkbox-container__label__eDDSv {
  opacity: 0.6;
  cursor: not-allowed;
}
.Checkbox_checkbox-container__checkbox__dpP8F {
  border: 2px solid var(--m-icon-color);
  border-radius: 4px;
  background: none;
  cursor: pointer;
  line-height: 0;
  outline: 0;
  padding: 0 !important;
  height: 1.2rem;
  min-height: 1.2rem;
  max-height: 1.2rem;
  width: 1.2rem;
  min-width: 1.2rem;
  max-width: 1.2rem;
  -webkit-appearance: none;
  position: relative;
}
.Checkbox_checkbox-container__checkbox__dpP8F:checked:not(.Checkbox_checkbox-container__checkbox--indeterminate__NQ2cz) {
  background-color: var(--m-primary);
  border-color: var(--m-primary);
  opacity: 1;
}
.Checkbox_checkbox-container__checkbox__dpP8F:checked:not(.Checkbox_checkbox-container__checkbox--indeterminate__NQ2cz)::before {
  content: "";
  position: absolute;
  width: 0.75rem;
  height: 0.75rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
}
.Checkbox_checkbox-container__checkbox--indeterminate__NQ2cz {
  display: flex;
  align-items: center;
  justify-content: center;
}
.Checkbox_checkbox-container__checkbox--indeterminate__NQ2cz:checked {
  background-color: var(--m-primary);
  border-color: var(--m-primary);
  opacity: 1;
}
.Checkbox_checkbox-container__checkbox--indeterminate__NQ2cz:checked::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 0.7rem;
  height: 3px;
  border-radius: 1px;
  background-color: var(--m-white);
  transform: translate(-50%, -50%);
  z-index: 2;
}
.Checkbox_checkbox-container__checkbox--invalid__7RARj {
  border-color: var(--m-danger-bolder);
}
.Checkbox_checkbox-container__checkbox--small__CuZaR {
  min-width: 1rem;
  max-width: 1rem;
  min-height: 1rem;
  max-height: 1rem;
}
.Checkbox_checkbox-container__checkbox--small__CuZaR:checked:not(.Checkbox_checkbox-container__checkbox--indeterminate__NQ2cz) {
  background-color: var(--m-primary);
  border-color: var(--m-primary);
  opacity: 1;
}
.Checkbox_checkbox-container__checkbox--small__CuZaR:checked:not(.Checkbox_checkbox-container__checkbox--indeterminate__NQ2cz)::before {
  width: 0.65rem;
  height: 0.65rem;
  left: 50%;
  top: 50%;
  transform: translate(-46%, -50%);
}
.Checkbox_checkbox-container__checkbox--small__CuZaR .Checkbox_checkbox-container__checkbox--indeterminate__NQ2cz:checked {
  background-color: var(--m-primary);
  border-color: var(--m-primary);
}
.Checkbox_checkbox-container__checkbox--small__CuZaR .Checkbox_checkbox-container__checkbox--indeterminate__NQ2cz:checked::before {
  left: 50%;
  top: 50%;
  width: 0.6rem;
  height: 2px;
  transform: translate(-50%, -50%);
  z-index: 2;
  background-color: var(--m-white);
}
.Checkbox_checkbox-container__checkbox__dpP8F:disabled {
  background-color: var(--m-subtle);
  cursor: not-allowed;
}
.Checkbox_checkbox-container__label__eDDSv {
  position: relative;
  display: flex;
  align-items: center;
}
.Checkbox_checkbox-container__message__TJiFc {
  position: absolute;
  bottom: 0;
  margin-bottom: -25px;
  font-size: 13px;
  color: var(--m-danger-bolder);
  width: 100%;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Checkbox/Checkbox.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;EAGA,kBAAA;AACJ;AACI;EACI,mBAAA;AACR;AACQ;EACI,YAAA;EACA,mBAAA;AACZ;AAGI;EACI,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;AADR;AAGQ;EACI,kCAAA;EACA,8BAAA;EACA,UAAA;AADZ;AAGY;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AADhB;AAKQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAHZ;AAKY;EACI,kCAAA;EACA,8BAAA;EACA,UAAA;AAHhB;AAKgB;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,gCAAA;EACA,UAAA;AAHpB;AAQQ;EACI,oCAAA;AANZ;AASQ;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAPZ;AASY;EACI,kCAAA;EACA,8BAAA;EACA,UAAA;AAPhB;AASgB;EACI,cAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAPpB;AAYgB;EACI,kCAAA;EACA,8BAAA;AAVpB;AAYoB;EACI,SAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,gCAAA;EACA,UAAA;EACA,gCAAA;AAVxB;AAgBQ;EACI,iCAAA;EACA,mBAAA;AAdZ;AAkBI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AAhBR;AAmBI;EACI,kBAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;AAjBR","sourcesContent":[".checkbox-container {\n    display: flex;\n    gap: 10px;\n    flex-direction: column;\n    position: relative;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n\n    &--disabled {\n        cursor: not-allowed;\n\n        .checkbox-container__label {\n            opacity: 0.6;\n            cursor: not-allowed;\n        }\n    } \n\n    &__checkbox {\n        border: 2px solid var(--m-icon-color);\n        border-radius: 4px;\n        background: none;\n        cursor: pointer;\n        line-height: 0;\n        outline: 0;\n        padding: 0 !important;\n        height: 1.2rem;\n        min-height: 1.2rem;\n        max-height: 1.2rem;\n        width: 1.2rem;\n        min-width: 1.2rem;\n        max-width: 1.2rem;\n        -webkit-appearance: none;\n        position: relative;\n\n        &:checked:not(.checkbox-container__checkbox--indeterminate) {\n            background-color: var(--m-primary);\n            border-color: var(--m-primary);\n            opacity: 1;\n            \n            &::before {\n                content: '';\n                position: absolute;\n                width: 0.75rem; \n                height: 0.75rem;\n                left: 50%;\n                top: 50%; \n                transform: translate(-50%, -50%);\n                background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"white\" stroke-width=\"4.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"20 6 9 17 3 12\"/></svg>');\n                background-size: contain;\n                background-repeat: no-repeat;\n            }\n        }\n        \n        &--indeterminate {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            \n            &:checked {\n                background-color: var(--m-primary);\n                border-color: var(--m-primary);\n                opacity: 1;\n                \n                &::before {\n                    content: '';\n                    position: absolute;\n                    left: 50%;\n                    top: 50%;\n                    width: 0.70rem;\n                    height: 3px;\n                    border-radius: 1px;\n                    background-color: var(--m-white);\n                    transform: translate(-50%, -50%);\n                    z-index: 2;\n                }\n            }\n        }\n        \n        &--invalid {\n            border-color: var(--m-danger-bolder);\n        }\n\n        &--small {\n            min-width: 1rem;\n            max-width: 1rem;\n            min-height: 1rem;\n            max-height: 1rem;\n\n            &:checked:not(.checkbox-container__checkbox--indeterminate) {\n                background-color: var(--m-primary);\n                border-color: var(--m-primary);\n                opacity: 1;\n\n                &::before {\n                    width: 0.65rem;\n                    height: 0.65rem;\n                    left: 50%;\n                    top: 50%;\n                    transform: translate(-46%, -50%);\n                }\n            }\n    \n            .checkbox-container__checkbox--indeterminate {\n                &:checked {\n                    background-color: var(--m-primary);\n                    border-color: var(--m-primary);\n                \n                    &::before {\n                        left: 50%;\n                        top: 50%;\n                        width: 0.60rem;\n                        height: 2px;\n                        transform: translate(-50%, -50%);\n                        z-index: 2;\n                        background-color: var(--m-white);\n                    }\n                }\n            }\n        }\n\n        &:disabled {\n            background-color: var(--m-subtle);\n            cursor: not-allowed;\n        }\n    }\n\n    &__label {\n        position: relative;\n        display: flex;\n        align-items: center;\n    }\n\n    &__message {\n        position: absolute;\n        bottom: 0;\n        margin-bottom: -25px;\n        font-size: 13px;\n        color: var(--m-danger-bolder);\n        width: 100%;\n        font-weight: 400;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox-container": `Checkbox_checkbox-container__Gpp8K`,
	"checkbox-container--disabled": `Checkbox_checkbox-container--disabled__Rfr+3`,
	"checkbox-container__label": `Checkbox_checkbox-container__label__eDDSv`,
	"checkbox-container__checkbox": `Checkbox_checkbox-container__checkbox__dpP8F`,
	"checkbox-container__checkbox--indeterminate": `Checkbox_checkbox-container__checkbox--indeterminate__NQ2cz`,
	"checkbox-container__checkbox--invalid": `Checkbox_checkbox-container__checkbox--invalid__7RARj`,
	"checkbox-container__checkbox--small": `Checkbox_checkbox-container__checkbox--small__CuZaR`,
	"checkbox-container__message": `Checkbox_checkbox-container__message__TJiFc`
};
export default ___CSS_LOADER_EXPORT___;
